import { Card, Avatar, Button, Checkbox, Divider, InlineGrid, InlineStack, Icon, Image, Link, Pagination, RadioButton, Tag, Text, Tooltip, BlockStack } from "@shopify/polaris";
import { ImportIcon, ExportIcon, CursorFilledIcon, ClockIcon } from "@shopify/polaris-icons";
import { useState } from "react";
import { usePartnerUp } from "../providers/PartnerUpStoreProvider";
import { getBestAvatar, shortenNumber } from "../utils";

export default function PostsLibrary({ posts, columns = "5", showCreator = true, showDetails = true, postsStatus = {}, setPostsStatus }) {

  const { leads } = usePartnerUp();
  const [carousels, setCarousels] = useState([]);

  console.log('posts', posts)

  return (
    <BlockStack gap="500">
      {posts?.length ? (
        <InlineGrid gap="300" columns={{ xs: "1", md: columns }}>
          {posts.map((post, index) => {
            const creator = leads.find(lead => lead.id === post?.creatorID);
            const date = new Date(post?.platform === 'youtube' ? post?.timestamp : post?.timestamp * 1000);
            const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

            // Get month, day, and year from the Date object
            const month = monthNames[date.getMonth()];
            const day = date.getDate();
            const year = date.getFullYear();

            // Format the date string
            const formattedDate = `${month} ${day}, ${year}`;

            const platform = creator?.platform || creator?.profile?.platform || creator?.profile?.profile?.platform;
            const creatorHandle = creator?.handle || creator?.profile?.handle || creator?.profile?.username || creator?.profile?.profile?.username;

            let postURL = '';
            if (post?.platform === 'instagram') {
              postURL = `https://instagram.com/${creatorHandle}/p/${post?.code}`;
            } else if (post?.platform === 'tiktok') {
              postURL = `https://tiktok.com/@${creatorHandle}/video/${post?.id}`;
            } else if (post?.platform === 'youtube') {
              postURL = `https://youtube.com/watch?v=${post?.id}`;
            }

            return (
              <Card key={index}>
                <BlockStack gap="300">
                  <InlineStack align="space-between" blockAlign="center">
                    <Text>{formattedDate}</Text>
                    {
                      showDetails ? (
                        <InlineStack gap="200">
                          <Button plain icon={ExportIcon} size='slim' url={postURL}></Button>
                          <Button plain icon={ImportIcon} download={true} url={post?.content?.video_url || post?.content?.display_url} size='slim'></Button>
                        </InlineStack>
                      ) : (
                        <InlineStack gap="200">
                          <Checkbox label="Done" checked={postsStatus?.[post.id] === 'pay'} onChange={v => {
                            const newPostsStatus = { ...postsStatus };
                            if (newPostsStatus[post.id] === 'pay') {
                              delete newPostsStatus[post.id];
                            } else {
                              newPostsStatus[post.id] = 'pay';
                            }
                            setPostsStatus(newPostsStatus);
                          }} />
                        </InlineStack>
                      )
                    }
                  </InlineStack>
                  <Divider />
                  {
                    showDetails ? (
                      <InlineStack align="space-between">
                        {
                          showCreator ? (
                            <InlineStack gap="200" align="start">
                              <Avatar shape="square" size="small" source={getBestAvatar(creator)} initials={creator?.name?.[0] || null} />
                              <BlockStack>
                                <Text>{creator?.name}</Text>
                                <Link removeUnderline url={`https://${platform}.com/${platform !== 'instagram' ? '@' : ''}${creatorHandle}`}>@{creatorHandle}</Link>
                              </BlockStack>
                            </InlineStack>
                          ) : null
                        }
                        {
                          post?.stats?.engagement ? (
                            <Tooltip content="Engagement Rate">
                              <InlineStack>
                                <Icon color="subdued" source={CursorFilledIcon} />
                                <Text variant="bodyLg">{(post?.stats?.engagement * 100)?.toFixed(2)}%</Text>
                              </InlineStack>
                            </Tooltip>
                          ) : null
                        }
                      </InlineStack>
                    ) : null
                  }
                  <Link url={(platform === 'tiktok' || post?.content?.video_url) ? postURL : platform === 'youtube' ? `https://youtube.com/watch?v=${post?.id}` : null}>
                    <div style={{
                      height: '250px',
                      width: '100%',
                      backgroundColor: 'lightgray',
                      backgroundImage: `url(${carousels[index] ? post?.content?.carousel_media[carousels[index]] : post?.content?.display_url})`,
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}>
                      {
                        platform === 'tiktok' || post?.content?.video_url || platform === 'youtube' ? (
                          <div style={{ background: "lightgrey", borderRadius: '100%', width: '50px', height: '50px' }}>
                            <img src="https://assets.codepen.io/6060109/pb-vector.svg" style={{ width: '50px', height: '50px' }} />
                          </div>
                        ) : null
                      }
                    </div>
                  </Link>
                  {
                    platform === 'instagram' ? (
                      <div style={{ height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <Text variant="headingMd">{post?.type === 'carousel_container' ? 'Carousel' : post?.type === 'clips' ? 'Reel' : 'Post'}</Text>
                        {
                          post?.type === 'carousel_container' ? (
                            <Pagination
                              hasPrevious={carousels[index]}
                              hasNext={!carousels[index] || post?.content?.carousel_media_count - 1 < carousels[index]}
                              onPrevious={() => {
                                const newCarousels = [...carousels];
                                newCarousels[index]--;
                                setCarousels(newCarousels);
                              }}
                              onNext={() => {
                                const newCarousels = [...carousels];
                                newCarousels[index] = newCarousels[index] ? newCarousels[index] + 1 : 1;
                                setCarousels(newCarousels);
                              }}
                            />
                          ) : null
                        }
                      </div>
                    ) : null
                  }
                  {
                    showDetails ? (
                      <div style={{ height: '50px' }}>
                        <Text variant="bodySm">{post?.desc?.slice(0, 100)}{post?.desc?.length > 100 ? '...' : ''}</Text>
                      </div>
                    ) : null
                  }
                  <InlineStack gap="200">
                    {
                      post?.stats?.plays ? (
                        <Tag>{shortenNumber(post?.stats?.plays)} Plays</Tag>
                      ) : null
                    }
                    {
                      post?.stats?.views ? (
                        <Tag>{shortenNumber(post?.stats?.views)} Views</Tag>
                      ) : null
                    }
                    <Tag>{shortenNumber(post?.stats?.likes)} Likes</Tag>
                    <Tag>{shortenNumber(post?.stats?.comments)} Comments</Tag>
                  </InlineStack>
                </BlockStack>
              </Card>
            )
          })
          }
        </InlineGrid>
      ) : <Card>
        <InlineStack gap="300" align="start">
          <InlineStack>
            <Icon source={ClockIcon} color="subdued" />
          </InlineStack>
          <BlockStack>
            <Text variant="headingSm">No Posts Yet</Text>
            <Text color="subdued">We check for new posts every 24h</Text>
          </BlockStack>
        </InlineStack>
      </Card>}
    </BlockStack>
  )
}
